import { useCallback } from 'react';
import { PosSearchBox } from 'src/core/POS/PosSearchBox';

import { useCatchUpSearchContext } from './CatchUpSearchContext';

export function CatchUpEventSearchBox() {
  const { searchText, setSearchText } = useCatchUpSearchContext();

  const onSearchChange = useCallback(
    (value: string) => {
      setSearchText(value);
    },
    [setSearchText]
  );

  return (
    <PosSearchBox
      value={searchText}
      placeholder="Search for event"
      onSearchChange={onSearchChange}
      minWidth={200}
      maxWidth={350}
    />
  );
}
